import { type ReactNode } from 'react';
import { cn } from '../utils/styles';

export interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  backButton?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, backButton, className }: PageHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4 border-b border-white/20 pb-4', className)}>
      <div className="flex items-start gap-3">
        {backButton}
        <div>
          <h1 className="text-xl font-extrabold text-neutral-900 sm:text-2xl">{title}</h1>
          {description && <p className="mt-1 text-sm text-neutral-500">{description}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
